var f = Object.defineProperty, g = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var e = (r, o, t) => o in r ? f(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t, m = (r, o) => {
  for (var t in o || (o = {}))
    n.call(o, t) && e(r, t, o[t]);
  if (a)
    for (var t of a(o))
      p.call(o, t) && e(r, t, o[t]);
  return r;
}, s = (r, o) => g(r, i(o));
import c, { forwardRef as I } from "react";
import d from "../lib/IconBase.mjs";
import l from "../defs/InstagramLogo.mjs";
const w = I((r, o) => /* @__PURE__ */ c.createElement(d, s(m({ ref: o }, r), { weights: l })));
w.displayName = "InstagramLogo";
export {
  w as InstagramLogo
};
